export default "__VITE_ASSET__bed19ed1__"